module.exports = "\r\n.martop20{\r\n    margin-top: 20px;\r\n    padding: 10px 5px;\r\n}\r\n.row{\r\n    padding:5px 0px 0px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n.form-group label{\r\n    color: #0000ff;    \r\n    font-size: 16px;\r\n    font-weight: normal\r\n}\r\n.border{\r\n    border:1px solid gray;\r\n    padding: 0px 15px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/psadetails/form5/form5.component.css
// module id = ./src/app/pages/functions/psadetails/form5/form5.component.css
// module chunks = main